<template>
  <div id="app" c_name="PcApp" class="pc_main">
    <TopPc />
    <router-view/>
    <BottomPc />
    <div class="btm_top" :style="{right: fixRight + 'px'}">
      <div class="btm_top_main">
        <div class="fix_code">
          <span @click="onShowCode">
            <img class="code_img" :style="{transform: 'scale(' + codeScalse + ')'}" src="@/assets/gzh_ewm_2.png" alt="">
          </span>
        </div>
        <div class="fix_top">
          <span @click="onToTop">
            <img class="top_img" src="@/assets/to_top.png" alt="">
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import TopPc from '@/components/TopPc.vue'
import BottomPc from '@/components/BottomPc.vue'
import tools from '@/tools/tools'

export default {
  name: 'PcHome',
  components: {
    BottomPc,
    TopPc
  },
  data: () => {
    return {
      fixRight: 0,
      codeScalse: 0.8
    }
  },
  mounted () {
    const self = this
    self.onResize()
    window.onresize = function () {
      self.onResize()
    }
    // 发送app安装参数消息
    tools.sendInstallParam()
    // 初始化 openinstall
    tools.initOpenInstall(this.$store.state.configs.openInstall)
  },
  methods: {
    // 处理回到顶部的贴边
    onResize () {
      const self = this
      const wcw = document.body.clientWidth
      if (wcw > 1200) {
        self.fixRight = (wcw - 1200) / 2
      } else {
        self.fixRight = 0
      }
    },
    onToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    onShowCode () {
      if (this.codeScalse < 1) {
        this.codeScalse = 1
      } else {
        this.codeScalse = 0.5
      }
    }
  }
}
</script>

<style>
#app {
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
article, aside, body, dd, details, dl, dt, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, html, label, li, menu, nav, ol, p, section, table, td, th, ul {
    margin: 0;
    padding: 0;
}
li, ol, ul {
    list-style: none outside none;
}
* {
  margin: 0;
  padding: 0;
}
.pc_main {
  width: 1200px;
  margin: auto;
}
body {
  margin: 0;
}
.page_space {
  margin-top: 1rem;
}

.btm_top {
  position: fixed;
  bottom: 30%;
  z-index: 999999;
}
.fix_code {
  margin-right: 20px;
  margin-bottom: 10px;
}
.fix_top {
  margin-right: 20px;
  text-align: right;
}
.code_img {
  transition: 0.2s;
  transform: scale(0.5);
  transform-origin: 100% 100% 0;
}
.top_img {
  width: 32px;
}
.code_img:hover {
  cursor: pointer;
}
.top_img:hover {
  cursor: pointer;
}
.page_space {
  margin-top: 1rem;
}

.page_top {
  margin-top: 4rem;
}
.page_bg {
  background: rgb(246,247,251);
}
.page_text_protocol {
  padding: 2rem 3rem;
  text-align: left;
}
.ql-align-center {
 text-align: center;
}
.page_text_protocol h3 {
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
}
.page_text_protocol dd {
  margin-left: 0;
}
.page_text_protocol dd p{
  text-indent: 2em;
}

.ml_05 {
  margin-left: 0.5rem;
}
.ml_1 {
  margin-left: 1rem;
}
</style>
